<template>
  <div>
    <courses-container />
  </div>
</template>

<style scoped>
</style>
<script>
import CoursesContainer from '@/app/modules/courses/containers/course-container/courses-container.vue';

export default {
  name: 'courses',
  components: {
    CoursesContainer,
  },
  async mounted() {
    await this.$store.dispatch('billing/initBillingAPI');
  },
};
</script>
